import React, {useState} from 'react';
import classes from './header.module.css';
import {Drawer, Flex, Image} from "antd";
import {Link, useNavigate} from "react-router-dom";
import {useWindowSize} from "@uidotdev/usehooks";
import {Fade} from "react-awesome-reveal";
import burger from '../../../images/burger.svg';
import Logo from "../Logo/Logo";
import {useScroll} from "../../../components/Scroll/Scroll";
import IntlMessage from "../../../components/IntlMessage/IntlMessage";
import GreenLightButton from "../../../components/UI/Buttons/GreenLightButton";
import { clrs } from '../../../constants/colors';

// Navigation config for easy upgrades
const NAV_LINKS = [
    {
        to: '/',
        label: <IntlMessage id={'homePage'}/>,
        scrollTo: '',
        className: classes.hoverText,
    },
    {
        to: '#about',
        label: <IntlMessage id={'homePage.aboutUs'}/>,
        scrollTo: 'about',
        className: classes.hoverText,
    },
    {
        to: '#contacts',
        label: <IntlMessage id={'homePage.contacts'}/>,
        scrollTo: 'contacts',
        className: classes.hoverText,
    },
    {
        to: '/water-analysis',
        label: 'Анализ воды',
        scrollTo: '',
        className: classes.hoverText,
    },
    {
        to: '/weather-map',
        label: 'Карта погоды',
        scrollTo: '',
        className: classes.hoverText,
    },
];

const CABINET_LINK = {
    to: '/login',
    label: <IntlMessage id={'homePage.monitoring'}/>,
    external: false,
};

// NavLinks subcomponent
const NavLinks = ({scroll, onClick}) => (
    <Flex align={"center"} justify={"center"} gap={25}>
        {NAV_LINKS.map((link) => (
            <Link
                key={link.to}
                to={link.to}
                onClick={link.scrollTo ? () => {
                    scroll(link.scrollTo);
                    if (onClick) onClick();
                } : onClick}
                className={link.className}
            >
                {link.label}
            </Link>
        ))}
    </Flex>
);

// HeaderDrawer subcomponent for mobile
const HeaderDrawer = ({open, setOpen, scroll}) => (
    <Drawer style={{backgroundColor: clrs.blue}} width={300} placement={'left'} open={open} onClose={() => setOpen(false)}>
        <Flex style={{width: "100%"}} gap={35} vertical align={"center"} justify={"center"}>
            <Logo/>
            <Flex gap={30} align={"center"} vertical justify={"center"}>
                <NavLinks scroll={scroll} onClick={() => setOpen(false)}/>
                <Link to={CABINET_LINK.to} target={CABINET_LINK.external ? "_blank" : undefined}>
                    <GreenLightButton style={{fontSize: "1rem", padding: "10px 20px"}}>
                        {CABINET_LINK.label}
                    </GreenLightButton>
                </Link>
            </Flex>
        </Flex>
    </Drawer>
);

// HeaderMain subcomponent for desktop
const HeaderMain = ({scroll}) => (
    <div className={classes.header}>
        <div className={classes.wrapper}>
            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                <Logo/>
            </Fade>
            <Flex gap={30} align={"center"} justify={"center"}>
                <Fade triggerOnce={true} cascade damping={0.25} direction={"down"}>
                    <NavLinks scroll={scroll}/>
                    <Link to={CABINET_LINK.to} target={CABINET_LINK.external ? "_blank" : undefined}>
                        <GreenLightButton style={{fontSize: "1rem", padding: "10px 20px"}}>
                            {CABINET_LINK.label}
                        </GreenLightButton>
                    </Link>
                </Fade>
            </Flex>
        </div>
    </div>
);

// Main Header component
const Header = () => {
    const [open, setOpen] = useState(false);
    const size = useWindowSize();
    const scroll = useScroll();

    if (size.width <= 768) {
        return (
            <div className={classes.header}>
                <div className={classes.wrapper}>
                    <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                        <Image preview={false} width={40} src={burger} onClick={() => setOpen(true)}
                               wrapperStyle={{cursor: "pointer", zIndex: 1000}} style={{zIndex: 1000}}/>
                    </Fade>
                    <Flex style={{width: "calc(100% - 40px - 70px)", marginLeft: 50, position: "absolute"}}
                          align={"center"} justify={"center"}>
                        <Logo/>
                    </Flex>
                    <HeaderDrawer open={open} setOpen={setOpen} scroll={scroll}/>
                </div>
            </div>
        );
    }

    return <HeaderMain scroll={scroll}/>;
};

export default Header;